import { render, staticRenderFns } from "./AssignPermissions.vue?vue&type=template&id=0a6eb7d0&scoped=true&"
import script from "./AssignPermissions.vue?vue&type=script&lang=js&"
export * from "./AssignPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6eb7d0",
  null
  
)

export default component.exports